import $http from '@/api';

const languageToolHost = window.location.origin;

const checkGrammar = (bodyText, language = 'auto') => {
  const data = {
    annotation: [{ text: bodyText }],
  };

  const params = new URLSearchParams();
  params.append('language', language);
  params.append('data', JSON.stringify(data));

  return $http.post(`${languageToolHost}/lt/v2/check`, params).catch((thrown) => {
    console.warn('Spell checker exception', thrown);
    return null;
  });
};

export default {
  checkGrammar,
};
